export const DASHBOARD = '/dashboard/v2/' as const

export const DASHBOARD_TEACHER = `${DASHBOARD}teacher` as const
